import { type ChartOptions } from "chart.js";
import { Bar } from "react-chartjs-2";
import { MixedChartData } from "../../types/UsersStats";

type Props = {
  data: MixedChartData;
};

export default function BaseComboChart({ data }: Props) {
  if (!data) return null;

  const { labels, bar, line, title, xAxisLabel } = data;

  const chartData: any = {
    labels,
    datasets: [
      {
        type: "bar" as const,
        label: bar.title,
        data: bar.data,
        backgroundColor: "rgba(247, 189, 55, 0.7)",
        borderColor: "rgba(247, 189, 55, 1)",
        borderWidth: 1,
        borderRadius: 4,
        maxBarThickness: 40,
        yAxisID: "y",
        offset: 4,
        datalabels: {
          anchor: "center" as const,
          align: "center" as const,
          formatter: (value: number) => value,
          font: {
            weight: "bold" as const,
            size: 10,
          },
        },
      },
      {
        type: "line" as const,
        label: line.title,
        data: line.data,
        borderColor: "rgba(54, 162, 235, 1)",
        backgroundColor: "rgba(54, 162, 235, 0.2)",
        pointBackgroundColor: "rgba(54, 162, 235, 1)",
        pointRadius: 4,
        pointHoverRadius: 6,
        borderWidth: 2,
        tension: 0.3,
        yAxisID: "y1",
        offset: 4,
        datalabels: {
          anchor: "end" as const,
          align: "top" as const,
          formatter: (value: number) => value,
          font: {
            weight: "bold" as const,
            size: 10,
          },
          color: "rgba(54, 162, 235, 1)",
        },
      },
    ],
  };

  const options: ChartOptions<"bar"> = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      autoPadding: true,
    },
    plugins: {
      title: { display: true, text: title },
      legend: { position: "top" },
      datalabels: { display: true, color: "#222" },
    },
    scales: {
      x: {
        title: { display: true, text: xAxisLabel, font: { weight: "bold" } },
        grid: { display: false },
      },
      y: {
        type: "linear" as const,
        position: "left",
        title: {
          display: true,
          text: bar.yAxisLabel ?? bar.title,
          font: { weight: "bold" },
        },
        grace: "10%",
        beginAtZero: true,
        grid: { color: "rgba(0,0,0,0.1)" },
      },
      y1: {
        type: "linear" as const,
        position: "right",
        title: {
          display: true,
          text: line.yAxisLabel ?? line.title,
          font: { weight: "bold" },
        },
        grace: "10%",
        beginAtZero: true,
        grid: { drawOnChartArea: false },
      },
    },
  };

  return (
    <div style={{ width: "100%", height: "400px", position: "relative" }}>
      <Bar options={options} data={chartData} />
    </div>
  );
}
